<template>
    <!--
        Needs refinement in the future.
        Likely need colors schemes and such. Waiting for designers.
    -->
    <div class="rounded-2xs p-sm"
        :class="classes">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
type Theme = 'green' | 'blue' | 'gray';

const properties = withDefaults(defineProps<{
    theme?: Theme
}>(), {
    theme: 'gray',
});

const themes: Record<Theme, string[]> = {
    green: [
        'bg-green-50',
        'border-green-50',
        'text-gray-900',
    ],
    blue: [
        'bg-blue-100',
        'border-blue-100',
        'text-gray-900',
    ],
    gray: [
        'bg-gray-50',
        'border-gray-50',
        'text-black',
    ],
};

const classes = computed(() => themes[properties.theme]);
</script>
